import { payPerLead } from "../constants/actionTypes";

const defaultErrors = {
  leadsLoad: null,
  hideLead: null
};

const defaultState = {
  filters: [],
  leads: [],
  loading: true,
  hideInFlightIds: [],
  pagination: {
    currentPage: null,
    currentPageNum: null,
    lastPage: null,
    lastPageNum: null,
    perPage: 0
  },
  tabsCounter: {
    new: 0,
    purchased: 0,
    hidden: 0
  },
  activeTab: "",
  activeSubTab: "",
  errors: {
    ...defaultErrors
  }
};

export default function(state = defaultState, action) {
  switch (action.type) {
    case payPerLead.SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    case payPerLead.SET_HIDE_IN_FLIGHT: {
      const leadId = String(action.payload.leadId);
      const current = state.hideInFlightIds || [];
      const hideInFlightIds = action.payload.isPending
        ? current.includes(leadId)
          ? current
          : [...current, leadId]
        : current.filter(id => id !== leadId);
      return {
        ...state,
        hideInFlightIds
      };
    }

    case payPerLead.SET_TAB:
      return {
        ...state,
        activeTab: action.payload.tab,
        activeSubTab: action.payload.subTab || ""
      };

    case payPerLead.SET_SUB_TAB:
      return {
        ...state,
        activeSubTab: action.payload
      };

    case payPerLead.GET_LEADS: {
      const parsePage = value => {
        if (value == null || value === "") {
          return 1;
        }
        if (typeof value === "number") {
          return value;
        }
        if (typeof value === "string" && /^\d+$/.test(value)) {
          return parseInt(value, 10);
        }
        return 1;
      };
      const apiLastPage = parsePage(action.payload.lastPage);
      const lastPageNum = Math.max(0, apiLastPage - 1);
      const currentPageNum = Math.max(0, parsePage(action.payload.currentPage) - 1);

      return {
        ...state,
        leads: action.payload.leads,
        filters: action.payload.filters,
        loading: false,
        errors: { ...state.errors, leadsLoad: null },
        pagination: {
          currentPage: action.payload.currentPage,
          currentPageNum,
          lastPage: action.payload.lastPage,
          lastPageNum,
          perPage: action.payload.perPage
        },
        tabsCounter: { ...action.payload.tabsCounter }
      };
    }

    case payPerLead.GET_LEADS_FAIL:
      return {
        ...state,
        loading: false,
        errors: {
          ...state.errors,
          leadsLoad: {
            message: action.payload?.message || "Couldn't load your leads",
            status: action.payload?.status || null
          }
        }
      };

    case payPerLead.SET_LEADS_CLEAR:
      return {
        ...state,
        leads: [],
        filters: [],
        loading: true,
        hideInFlightIds: [],
        errors: { ...defaultErrors },
        tabsCounter: {
          new: 0,
          purchased: 0,
          hidden: 0
        }
      };

    case payPerLead.SET_LEAD_HIDE_FAIL:
      return {
        ...state,
        errors: {
          ...state.errors,
          hideLead: {
            message: action.payload?.message || "Couldn't update this lead. Please try again.",
            status: action.payload?.status || null
          }
        }
      };

    case payPerLead.CLEAR_ERROR:
      return {
        ...state,
        errors: { ...state.errors, [action.payload]: null }
      };

    case payPerLead.SET_LEAD_NO_INTEREST: {
      const leadId = String(action.payload);
      const hideInFlightIds = (state.hideInFlightIds || []).filter(id => id !== leadId);
      const lead = state.leads.find(item => String(item.lead_id) === leadId);
      if (!lead) {
        return {
          ...state,
          hideInFlightIds
        };
      }

      const fromSection = lead.purchased ? "purchased" : "new";
      return {
        ...state,
        leads: state.leads.filter(item => String(item.lead_id) !== leadId),
        loading: false,
        hideInFlightIds,
        errors: { ...state.errors, hideLead: null },
        tabsCounter: {
          ...state.tabsCounter,
          [fromSection]: Math.max(0, state.tabsCounter[fromSection] - 1),
          hidden: state.tabsCounter.hidden + 1
        }
      };
    }

    case payPerLead.LEAD_PURCHASED: {
      const purchasedId = String(action.payload);
      const leadInList = state.leads.some(item => String(item.lead_id) === purchasedId);
      if (!leadInList) {
        return {
          ...state,
          loading: false
        };
      }

      return {
        ...state,
        leads: state.leads.filter(item => String(item.lead_id) !== purchasedId),
        loading: false,
        tabsCounter: {
          ...state.tabsCounter,
          new: Math.max(0, state.tabsCounter.new - 1),
          purchased: state.tabsCounter.purchased + 1
        }
      };
    }

    case payPerLead.SET_LEAD_INTEREST: {
      const leadId = String(action.payload);
      const hideInFlightIds = (state.hideInFlightIds || []).filter(id => id !== leadId);
      const lead = state.leads.find(item => String(item.lead_id) === leadId);
      if (!lead) {
        return {
          ...state,
          hideInFlightIds
        };
      }

      const toSection = lead.purchased ? "purchased" : "new";
      return {
        ...state,
        leads: state.leads.filter(item => String(item.lead_id) !== leadId),
        loading: false,
        hideInFlightIds,
        errors: { ...state.errors, hideLead: null },
        tabsCounter: {
          ...state.tabsCounter,
          [toSection]: Math.max(0, state.tabsCounter[toSection] + 1),
          hidden: Math.max(0, state.tabsCounter.hidden - 1)
        }
      };
    }

    default:
      return state;
  }
}
